export default {
    downgrade: 'Downgrade',
    dropdownSelect: {
        clearSelection: 'Clear selection',
        itemSelected_one: '{{count}} item selected',
        itemSelected_other: '{{count}} items selected',
        optionSelected_one: '{{count}} item selected',
        optionSelected_other: '{{count}} items selected',
    },
    edit: 'Edit',
    footer: {
        links: {
            about: 'About',
            api: 'API',
            helpCenter: 'Help Center',
            qAndA: 'Q&A',
            status: 'Status',
        },
    },
    header: {
        freeTrial: 'Free Trial',
        freeTrialEndsIn: 'Free Trial ends in 26 days',
        menu: {
            billing: 'Billing',
            buyMailPoints: 'Buy MailPoints',
            changePlan: 'Change Plan',
            en: 'English',
            ja: '日本語',
            profile: 'Profile',
            signout: 'Sign Out',
        },
        signIn: 'Sign in',
        upgrade: 'Upgrade',
    },
    helpText: {
        building: 'e.g. ◯◯◯ビル◯階',
        city: 'e.g. 新宿区、大阪市北区',
        neighborhood: 'e.g. 西新宿0-0-0',
        phoneNumber: 'e.g. 000-0000-0000',
        postcode: 'e.g. 000-0000',
        username:
            'Choose a username that contains only letters, numbers, and ,/+/-/_. This is for login only.',
    },
    next: 'Next',
    noResultsFound: 'No results found',
    password: {
        confirm: 'Confirm Password',
        input: 'Password',
        letter: 'At least 1 letter',
        min: 'At least 8 characters',
        mismatch: 'Passwords do not match',
        number: 'At least 1 number',
        symbol: 'At least 1 symbol (Choose from: !_+.-,$\'=@;*:"(&)?[^]%~#)',
    },
    pdfMenu: {
        actual: 'Actual Size',
        automatic: 'Automatic Zoom',
        page: '<0></0> of {{ numPages }}',
    },
    preview: 'Preview',
    search: 'Search',
    tooltip: {
        close: 'Close',
        learnMore: 'Learn More',
    },
    warning: 'Warning',
};
